import React, { useContext } from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import RecordDataValidation from "./Forms/RecordDataValidation";
import FieldDataValidation from "./Forms/FieldDataValidation/FieldDataValidation";
import { ParentScreenCtx } from "/src/pages/workbench_build/WorkbenchBuild";
import SubQuery from "./SubQuery";
import FieldGroupDataValidation from "./Forms/FieldGroupDataValidation";
export default function DataValidation(props) {
  const { t } = useTranslation();
  const parentScreen = useContext(ParentScreenCtx);
  const currentTab = useSelector(
    (state) => state.treeData[parentScreen].rightTree.currentTab
  );
  const selectedNode = useSelector(
    (state) =>
      state.treeData[parentScreen].rightTree.tree[currentTab]
        .selectedNode
  );
  
  return (
    <div className="height-100 padding-12 overflow-auto">
      <div className={"height-100"}>
        {Object.keys(selectedNode).length === 0 || (selectedNode?.key === 'ib-0' && currentTab === "body") ?  (
          <div>{t('NO_FIELD_SELECTED')}</div>
        ) : (
          <>
            {(selectedNode?.ICON_DISPLAY === 'RECORD_LOOP') && <RecordDataValidation isVisible = {props.isVisible}/> }
            {selectedNode?.ICON_DISPLAY === 'RECORD' && <RecordDataValidation isVisible = {props.isVisible}/> }
              {selectedNode?.ICON_DISPLAY === 'QUERY' ? selectedNode?.key?.split('-')?.length > 3 && parentScreen !== "outbound" ? <SubQuery/> : <div className='panel-no-data'>{t('MSG_SUB_QUERIES')}</div> : ''}
            {["FIELD", "FIELD_LOOP"].includes(selectedNode?.ICON_DISPLAY) && <FieldDataValidation/>}
            {(selectedNode?.ICON_DISPLAY === 'FIELD_GROUP' || selectedNode?.ICON_DISPLAY === 'REPEATING_FIELD_GROUP')  && <FieldGroupDataValidation isVisible = {props.isVisible}/>}
          </>
          
        )}
      </div>
    </div>
  );
}

DataValidation.propTypes = {
  text: PropTypes.string,
};
